<template>
    <div class="bg-white p-4 h-[68px] rounded-lg shadow-md">
      <div class="flex flex-wrap">
        <div class="flex flex-1">
          <fwb-heading tag="h2" class="text-style-xl">
            Propiedad
          </fwb-heading>
        </div>
        <div class="flex flex-1 justify-end items-end">
          <fwb-breadcrumb>
            <fwb-breadcrumb-item href="/Propiedades">
              Lista de propiedades
            </fwb-breadcrumb-item>
  
            <fwb-breadcrumb-item> Agregar nuevo inmueble </fwb-breadcrumb-item>
          </fwb-breadcrumb>
        </div>
      </div>
  
      <!-- inicio de contenido -->
      <div
        class="w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 mt-5 sm:mt-10"      
      >
        <fwb-tabs
          v-model="activeTab"
          class="p-5"
        >
          <fwb-tab
            name="first"
            title="Datos generales"
          >
            <p class="text-sm font-normal leading-6 text-black "> 
              Por favor, completa todos los campos obligatorios marcados con un asterisco (*). 
              La información precisa y detallada ayudará a que tu inmueble destaque en el mercado. 
            </p>
            <div class="flex flex-col md:flex-row md:justify-between md:items-start">
              <!-- Links -->
              <div>
                <div v-for="(partner, index) in groupedPartners" :key="index" class="mb-4">
                  <p class="text-sm font-normal leading-6 text-black">
                    Consulta tu propiedad publicada en 
                    <strong>{{ partner.partner === 'EasyAviso' ? 'Pincali' : partner.partner }}</strong>:
                  </p>
                  <p v-if="partner.sale" class="text-sm font-normal leading-6 text-black">
                    🏷️ En venta: <a :href="partner.sale" target="_blank" class="text-blue-500">aquí</a>
                  </p>
                  <p v-if="partner.rent" class="text-sm font-normal leading-6 text-black">
                    📃 En renta: <a :href="partner.rent" target="_blank" class="text-blue-500">aquí</a>
                  </p>
                </div>
              </div>

              <!-- Fechas -->
              <div class="registro ml-0 mt-4 md:ml-6 md:mt-0">
                <label class="text-style-sm mb-1 block">Creación:</label>
                <span class="bg-white text-box block">{{ create_property }}</span>
                <label class="text-style-sm mb-1 block">Actualización:</label>
                <span class="bg-white text-box block">{{ updated_property }}</span>
              </div>
            </div>
  
            <FormComponent 
              :property-id="id" 
            />        
          </fwb-tab>
  
          <fwb-tab 
            name="gallery" 
            title="Galería" 
            :disabled="!active_tab"
          >
            <FormGalleryComponent 
              :property-id="id" 
            />
          </fwb-tab>

          <fwb-tab 
            name="video" 
            title="Video" 
            :disabled="!active_tab"
          >
            <FormVideoComponent
              :property-id="id" 
            />
          </fwb-tab>
  
          <fwb-tab 
            name="characters" 
            title="Características" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="characteristics"
            /> 
          </fwb-tab>
  
          <fwb-tab 
            name="amenities" 
            title="Amenidades" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="amenities"
            /> 
          </fwb-tab>
  
          <fwb-tab 
            name="service" 
            title="Servicios" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="service"
            /> 
          </fwb-tab>

          <fwb-tab 
            name="friendly" 
            title="Friendly" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="friendly"
            /> 
          </fwb-tab>
  
          <fwb-tab 
            name="requeriments" 
            title="Requisitos" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="requeriments"
            /> 
          </fwb-tab>
        </fwb-tabs>
      </div>
      <head>
          <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
      </head>
    </div>
  </template>
  <script setup>
  import FormCharacteristicsComponent from "@/components/properties/FormCharacteristicsComponent.vue";
  import FormComponent from "@/components/properties/FormComponent.vue";
  import FormGalleryComponent from "@/components/properties/FormGalleryComponent.vue";
  import FormVideoComponent from "@/components/properties/FormVideoComponent.vue";
  import axios from "axios";
  import {
    FwbBreadcrumb,
    FwbBreadcrumbItem,
    FwbHeading,
    FwbTab,
    FwbTabs,
  } from "flowbite-vue";
  import { ref, onMounted, watch, computed} from "vue";
  import { useRoute } from "vue-router";
  import { useStore } from "vuex";
  let store = useStore();
  let session = computed(() => store.getters.getUserSession);

  
  // Acceder al parámetro 'id' de la URL directamente
  const route = useRoute();
  let id = route.params.id;
  let active_tab = ref(false);
  const groupedPartners = ref([]);
  const activeTab = ref("first");
  let create_property = ref();
  let updated_property = ref();
  let propertyData = ref({}); 

  onMounted(async () => {
    if (id !== undefined) {
      active_tab.value = true;
      await getProperty();

      if (propertyData.value.partners && propertyData.value.partners.length > 0) {
        const temp = {};

        propertyData.value.partners.forEach(partner => {
          if (partner.status !== 'active') return;

          const key = partner.partner;

          if (!temp[key]) {
            temp[key] = {
              partner: key,
              sale: null,
              rent: null
            };
          }

          const type = partner.transaction_type.toLowerCase();

          // Clasificamos según tipo de transacción
          if (type === 'sale' || type === 'sale-rent') {
            if (!temp[key].sale) {
              temp[key].sale = partner.url;
            }
          } else if (type === 'rent' || type === 'rental') {
            if (!temp[key].rent) {
              temp[key].rent = partner.url;
            }
          }
        });

        // Convertir el objeto en array para iterar en template
        groupedPartners.value = Object.values(temp);
      }
    }
  });
  function formatDate(isoDate) {
    const date = new Date(isoDate);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  async function getProperty() {
    let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${id}`;

    var options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const response = await axios.get(url_cnn, options);
      const resp = response.data.resp;
      create_property.value = formatDate(resp.general.created_at);
      updated_property.value = formatDate(resp.general.updated_at);
      propertyData.value = resp; // Guardar los datos de la propiedad en propertyData
      console.log(propertyData.value);
    } catch (error) {
      console.log("[ERROR]", error.response);
    }
  }

  watch(
    () => route.params.id,
    (newId) => {
      console.log('[-----]', newId);
      id = newId;
      getProperty(); // Vuelve a cargar los datos cuando cambie el ID
    }
  );
  </script>